export const READ_ACCESS = "access.readAccess";
export const WRITE_ACCESS = "access.writeAccess";
export const MODIFY_ACCESS = "access.modifyAccess";
export const DELETE_ACCESS = "access.deleteAccess";

// "Communication Like/Love failed!!"
export const TARGET_TYPE = "targetData.type";
export const TARGET_STATUS = "targetData.targetStatus";
export const TARGET_USER = "targetUser.items";
export const TARGET_OBJECTIVE = "objectiveUser.items";
export const TARGET_DUEDATE = "targetData.dueDate";
export const TARGET_MSG_THREAD = "data.targetMessageThreadMutation";

export const SKILL_USERCHECKIN_ID = "skillModal.userCheckinId";
export const SKILL_RATEE_ID = "skillModal.rateeId";
export const SKILL_SCORE_DISPLAY =
  "data.saveSkillRatingResponse.scoreToDisplay";
export const SKILL_EMPLOYEE_LEVEL = "getEmployeeLevelSkillScoreDetails.skills";

export const RATEE_FIRSTNAME = "ratee.firstName";
export const RATEE_LASTNAME = "ratee.lastName";
export const RATER_FIRSTNAME = "rater.firstName";
export const RATER_LASTNAME = "rater.lastName";

export const FIELDS_USERGROUP_DESIGNATION =
  "userGroupFormData.field.designations";
export const FIELDS_USERGROUP_DEPARTMENT =
  "userGroupFormData.field.departments";
export const FIELDS_USERGROUP_LOCATION = "userGroupFormData.field.locations";

export const FIELDS_STARTDATE = "fields.startDate";
export const FIELDS_ENDDATE = "fields.endDate";
export const FIELDS_TC_ACCEPTED = "fields.termsAndConditionsAccepted";
export const FIELDS_PROFILE_EMAIL = "fields.profile.email";
export const FIELDS_PERFORMANCE_CYCLE = "fields.performanceCycle";
export const FIELDS_YEAR_STARTDATE = "0.yearStartDate";
export const FIELDS_YEAR_ENDDATE = "0.yearEndDate";
export const FIELDS_TC = "fields.termsAndConditions";
export const FIELDS_COACHEE = "fields.coachee";
export const FIELDS_COACHEE_GROUP = "fields.coacheeGroup";
export const FIELDS_COACHEE_DEPARTMENT = "fields.coacheeDepartment";
export const FIELDS_COACH = "fields.coach";
export const FIELDS_NAME = "field.name";
export const FIELDS_STRENGTH = "fields.strengths";
export const FIELDS_ISTARGETPUSBLISH = "fields.isTargetPublished";
export const FIELDS_COMPANY_ID = "fields.companyId";
export const FIELDS_EEID = "fields.eeid";
export const FIELDS_UNSPLASHCOVERIMAGE = "fields.unsplashCoverImage";

export const DATA_TARGET_COMMUNICATION = "data.targetCommunication";

export const FORMDATA_USERCHECKIN = "formData.checkinData.usercheckin";
export const FORMDATA_ERROR = "formData.error";
export const FORMDATA_SURVEYCHECKIN = "formData.surveyCheckin";

export const CHECKIN_EVENTDOCUMENT = "eventCheckin.documents";
export const SURVEY_CHECKIN = "surveyCheckin.surveycheckin";
export const CHECKIN_SUBMODULE_FREQ = "subModuleData.scheduleFrequency";
export const CHECKIN_SUBMODULE_STARTDATE = "subModuleData.startDate";
export const CHECKIN_USERCHECKIN = "usercheckin.items";
export const CHECKIN_USERANSWER = "userAnswer.0";
export const CHECKIN_USER_RESPOND_ID = "userRespond.id";
export const CHECKIN_USER_RESPOND_0_ID = "userRespond.0.id";
export const CHECKIN_DATA_USERCHECKIN = "checkinData.usercheckin";
export const CHECKIN_DATA_URL = "checkinData.checkInData.url";
export const CHECKIN_ATTACHMENT_TYPE = "checkinAttachement.attachmentType";
export const CHECKIN_ATTACHMENT_LINK = "checkinAttachement.link";
export const CHECKIN_USERCHECKIN_ID = "checkinData.userCheckinID";
export const CHECKIN_DATA_ID = "checkinData.id";
export const CHECKIN_CHECKINLINK = "checkinData.checkinLink";
export const CHECKIN_ASSIGNRATERS = "checkin.assignRaters";
export const CHECKINATTACHMENT_LINK = "checkinAttachment.link";

export const VISION_ENCORAGEMENT_WORD = "encouragementWords.items";
export const VISION_LIST_CUSTOM = "getUser.listVisionCustom.items";

export const GRID_COACH_FIRSTNAME = "dataItem.checkinCoachFirstName";
export const GRID_COACHEE_FIRSTNAME = "dataItem.coachees.firstName";
export const GRID_FIRSTNAME = "dataItem.firstName";
export const GRID_Result_Data = "result.data";
export const GRID_ISNEW = "dataItem.isNew";
export const GRID_SCHEDULE = "dataItem.schedule";
export const GRID_FREQUENCY = "dataItem.frequency";
export const GRID_CHECKIN_STATUS = "dataItem.checkInStatus";
export const GRID_CREATEDBY_FIRSTNAME = "dataItem.createdBy.firstName";
export const GRID_CREATEDBY_LASTNAME = "dataItem.createdBy.lastName";
export const GRID_USER_FIRSTNAME = "dataItem.user.firstName";
export const GRID_ITEM_STATUS = "dataItem.items.0.status";
export const GRID_CHECKINTYPE = "dataItem.checkInType";
export const GRID_MANAGER_FIRSTNAME = "dataItem.manager.firstName";
export const GRID_MANAGER_LASTNAME = "dataItem.manager.lastName";
export const GRID_STATUS = "dataItem.status";
export const GRID_TARGET_STATUS = "dataItem.targetStatus";
export const COMPANY_CYCLE_TYPE = "cycle.0.type";
export const COMPANY_FEATURE_TARGET = "companyData.feature.target";
export const COMPANY_FEATURE_CHECKIN = "companyData.feature.checkin";
export const FEATURE_CHECKIN = "feature.checkin";
export const FEATURE_LISTCHECKINS = "listCheckIns.items";

export const MSG_DOCUMENT = "message.documentUrl";
export const MSG_PARENT_ID = "message.parentMessageId";
export const MSG_GRANDPARENT_ID = "message.grandParentMessageId";
export const MSG_DESCRIPTION = "message.description";
export const MSG_TITLE = "message.title";
export const MSG_OBJECT_ID = "message.objectId";

export const CREATEDBY_FIRSTNAME = "createdBy.firstName";
export const CREATEDBY_LASTNAME = "createdBy.lastName";
export const CREATEDBY_FILENAME = "createdBy.profileImage.fileName";
export const EDIT_FORMDATA_ID = "editFormData.id";
export const USER_UPLOAD_FAILED = "data.uploadUsers.failedUsers";
export const USER_UPLOAD_SUCCESS = "data.uploadUsers.successfulUsers";
export const USER_FIRSTNAME = "user.firstName";
export const USER_LASTNAME = "user.lastName";
export const USER_PROFILEIMAGE_FILENAME = "user.profileImage.fileName";

export const USERPROFILE_LISTCHECKIN_CUSTOM =
  "userProfile.listCheckinCustom.items";
export const USERPROFILE_EEID = "userProfile.eeid";
export const USERPROFILE_PREFERREDNAME = "userProfile.preferredName";
export const USERPROFILE_LASTNAME = "userProfile.lastName";
export const USERPROFILE_FIRSTNAME = "userProfile.firstName";
export const USERPROFILE_ABOUTME = "userProfile.aboutMe";
export const USERPROFILE_TOP_STRENGTH = "userProfile.topStrengths";
export const USERPROFILE_GALLUP_URL = "userProfile.gallupSurveyReport.url";

export const VALUE_FIRSTNAME = "value.firstName";
export const VALUE_LASTNAME = "value.lastName";
export const VALUE_LOGO_FILENAME = "value.logo.fileName";
export const VALUE_PROFILEIMAGE_FILENAME = "value.profileImage.fileName";

export const AUTH_ERROR_NEW_PASSWORD =
  "changePasswordFormData.errors.newPasswordError";
export const AUTH_ERROR_CONFIRM_PASSWORD =
  "changePasswordFormData.errors.confirmPasswordError";
export const AUTH_ERROR_TENANT_ID = "formData.errors.tenantIdError";
export const AUTH_ERROR_EMAIL = "formData.errors.emailError";
export const AUTH_ERROR_Password = "formData.errors.passwordError";
export const ERROR_BADGE = "error.badge";

export const ADDEDITFORMDATA_ROLE = "addEditFormData.role";
export const GETUSER_COMPANY = "getUser.company";
export const MYTARGET_ID = "myTarget.id";
export const COMMETEDBY_FIRSTNAME = "commentedBy.firstName";
export const COACH_USERID = "coach.userid";
export const COACH_FIRSTNAME = "coach.firstName";
export const COACH_LASTNAME = "coach.lastName";

export const SIGNATURE_URL = "managerAcknowledgement.signature.key";
export const SUPERVISEE_SIGNATURE_URL =
  "superviseeAcknowledgement.signature.key";
export const ASSIGNEDUSER_USERID = "assignedUser.userId";

export const DISCUSSIONPOINT_CREATEDBY = "discussionPoints.createdBy";
export const DISCUSSIONPOINT_MANAGER = "discussionPoints.manager";
export const COACH_ID = "coach.id";
